import React, { useEffect, useState } from 'react';
import { Wrapper } from './styles';
import { Menu } from '../../../components/Menu';
import { usePages } from '../../../hooks/Pages';
import FooterLayout from '../../Footer';
import { useAuth } from '../../../hooks/Auth';
import PopupComponent from '../../../components/PopupContainer';

import Particles from 'react-particles-js';
import ImageSliderBackground from '../../../components/ImageBackgroundSlider';
import { useLocation, useParams } from 'react-router-dom';
import { useConfiguration } from '../../../hooks/Configuration';
import api from '../../../services/api';
import Loader from '../../DashboardPages/core/components/Loader';
import { urlWebsite } from '../../../config';
import MainLayout from '../header';

interface IParams {
  projectHash: string;
  eventHash: string;
}


const DefaultLayout: React.FC = ({ children }) => {
  const page = window.location.pathname !== '/';
  const { menu, setMenu, prepareMenu } = usePages();
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const { token,setTrackingMarketing, user, handleApiErrors, signOut } = useAuth();
  const { configuration, setConfiguration, setProjectHash, setEventHash } = useConfiguration();

  const [loading, setLoading] = useState(false);

  useEffect(() => {

    /* if (user && user.email !== 'guilherme@encontrodigital.com.br') {
        signOut();
        window.location.href = '/';
      } */



        

  }, [user])

  useEffect(() => {
  const marketing_params: Record<string, any> = {
      "src": params.get("src") || '',
      "utm_source": params.get("utm_source") || '',
      "utm_medium": params.get("utm_medium") || '',
      "utm_content": params.get("utm_content") || '',
      "utm_campaign": params.get("utm_campaign") || '',
      "utm_term": params.get("utm_term") || ''
    }

    if (marketing_params?.src || marketing_params?.utm_source || marketing_params?.utm_campaign) {
      setTrackingMarketing(marketing_params);
    }



  },[])

  return (
    <MainLayout>
      {loading && <Loader message='Carregando' />}
      <Menu menuList={menu} fixedMenu={false} />
      <Wrapper background_color={configuration.background_color} background={`${urlWebsite}/${configuration.background}`}>



        {children}

        <PopupComponent />


    {/* Rodapé */}
      <footer style={{ background: '#2C3E4E', width: '100%', color: "#fff" }}>
        <div
          style={{
            maxWidth: "720px",
            margin: "0 auto",
            padding: "2.5rem 1.25rem",
            boxSizing: "border-box",
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "1.25rem",
          }}
        >
          <div>
            <div style={{ fontWeight: 800, fontSize: "1.05rem", letterSpacing: "-0.01em" }}>
              Guia Rápido dos Estudantes
            </div>
            <div style={{ fontSize: "0.85rem", color: "rgba(255,255,255,0.6)", marginTop: "0.25rem" }}>
              Cursos de Especialização
            </div>
          </div>
 
          <a
            href="/faq-especializacoes"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "0.5rem",
              padding: "0.7rem 1.25rem",
              borderRadius: "100px",
              background: '#63B887',
              color: "#fff",
              fontWeight: 700,
              fontSize: "0.92rem",
              textDecoration: "none",
              transition: "filter 0.2s",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.filter = "brightness(1.08)")}
            onMouseLeave={(e) => (e.currentTarget.style.filter = "none")}
          >
            Ver FAQ completo
            <span aria-hidden style={{ fontSize: "1.05rem", lineHeight: 1 }}>→</span>
          </a>
        </div>
      </footer>
      </Wrapper>
    </MainLayout>
  );
};

export default DefaultLayout;
